import {
  getDaysUntilHandback,
  isWithinTourHandbackUrgencyWindow,
} from 'lib/tours/tourUtils'
import LineStopwatchIcon from 'LuxKit/Icons/line/LineStopwatchIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { useIntl } from 'react-intl'

const urgencyStartIcon = <LineStopwatchIcon />

interface Props {
  handbackDate?: string
}

function DepartureUrgencyLabel(props: Props) {
  const intl = useIntl()
  const daysLeft = getDaysUntilHandback(props.handbackDate)

  if (daysLeft === undefined || !isWithinTourHandbackUrgencyWindow(daysLeft)) {
    return null
  }

  const lastDayLabel = intl.formatMessage({
    id: 'qS-fojNycma0IDQ2NhUA',
    defaultMessage: 'Last day to book',
    description: 'Urgency label shown on a tour departure when the handback date is today',
  })
  const endingSoonLabel = intl.formatMessage({
    id: 'XjFW9RCaYjLwhfqZel6H',
    defaultMessage: 'Ending in {count, plural, one {# day} other {# days}}',
    description: 'Urgency label showing how many days remain before a tour departure handback date',
  }, { count: daysLeft })
  const daysLeftToBookLabel = intl.formatMessage({
    id: '_Bw6XCRfk9YYqmcw7JEp',
    defaultMessage: '{count, plural, one {# day left to book} other {# days left to book}}',
    description: 'Urgency label showing how many days remain before a tour departure handback date',
  }, { count: daysLeft })
  const urgencyLabelMessage = daysLeft === 0
    ? lastDayLabel
    : daysLeft <= 3
      ? endingSoonLabel
      : daysLeftToBookLabel

  return <CaptionTextBlock
    variant="medium"
    weight="bold"
    colour="urgency"
    startIcon={urgencyStartIcon}
  >
    {urgencyLabelMessage}
  </CaptionTextBlock>
}

export default DepartureUrgencyLabel
